export default {
  GetPerformanceDetails: 'GetPerformanceDetails',
  GetScreens: 'GetScreens',
  GetSeatList: 'GetSeatList',
  ReserveTempCartSeats: 'ReserveTempCartSeats',
};



// WEBPACK FOOTER //
// ./src/syos/api/SyosServiceMethod.js